import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "product-card-wrapper io-eq-el" }
const _hoisted_2 = {
  key: 4,
  class: "product-card__bottom"
}
const _hoisted_3 = {
  key: 5,
  class: "product-card__bottom product-card__bottom--calculator"
}

import BaseButton from '@/components/BaseButton.vue';
import PriceDetailsTableInternet from '@/components/product/PriceDetailsTableInternet.vue';
import ProductCardAddons from '@/components/product/product-card/ProductCardAddons.vue';
import ProductCardBenefits from '@/components/product/product-card/ProductCardBenefits.vue';
import ProductCardBenefitsInternet from '@/components/product/product-card/ProductCardBenefitsInternet.vue';
import ProductCardCalculator from '@/components/product/product-card/ProductCardCalculator.vue';
import ProductCardPrices from '@/components/product/product-card/ProductCardPrices.vue';
import ProductCardPricesInternet from '@/components/product/product-card/ProductCardPricesInternet.vue';
import ProductCardRecommendation from '@/components/product/product-card/ProductCardRecommendation.vue';
import ProductCardTitle from '@/components/product/product-card/ProductCardTitle.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import {
  onBeforeUnmount,
  onMounted,
  ref,
  computed,
} from 'vue';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';
import { getRandomId } from '@/helpers';
import Product from '@/classes/Product';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    product: {},
    isSingle: { type: Boolean },
    preview: { type: Boolean },
    showCalculator: { type: Boolean },
    cartItemKey: {}
  },
  emits: ['order', 'cart'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const store = useStore();
const colLeft = ref<InstanceType<typeof HTMLElement>>();
const colRight = ref<InstanceType<typeof HTMLElement>>();
const btnSpacer = ref<InstanceType<typeof HTMLElement>>();
const cardKey = ref(getRandomId());

const branch = computed<BranchInterface | undefined>(() => store.getters['branches/all'].find((br: BranchInterface) => br.mainCategory.key === props.product.branch));

const emitOrder = () => {
  emit('order', props.product);
};

const setSpacerHeight = () => {
  if (colLeft.value && colRight.value && btnSpacer.value) {
    btnSpacer.value.style.height = '0px';
    const diff = colLeft.value.offsetHeight - colRight.value.offsetHeight;
    btnSpacer.value.style.height = `${diff}px`;
  }
};

onMounted(() => {
  window.addEventListener('resize', setSpacerHeight);
  window.addEventListener('load', setSpacerHeight);
  setSpacerHeight();
  setTimeout(setSpacerHeight, 250);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setSpacerHeight);
  window.removeEventListener('load', setSpacerHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProductCardRecommendation, {
      product: _ctx.product,
      "is-single": _ctx.isSingle
    }, null, 8, ["product", "is-single"]),
    _createElementVNode("div", {
      class: _normalizeClass(["product-card", { recommended: _ctx.product.isRecommended }])
    }, [
      _createVNode(ProductCardTitle, { product: _ctx.product }, null, 8, ["product"]),
      (!_ctx.product.isInternet)
        ? (_openBlock(), _createBlock(ProductCardBenefits, {
            key: 0,
            product: _ctx.product
          }, null, 8, ["product"]))
        : _createCommentVNode("", true),
      (_ctx.product.isInternet)
        ? (_openBlock(), _createBlock(ProductCardBenefitsInternet, {
            key: 1,
            product: _ctx.product
          }, null, 8, ["product"]))
        : _createCommentVNode("", true),
      (!_ctx.product.isInternet && _ctx.product.price)
        ? (_openBlock(), _createBlock(ProductCardPrices, {
            key: 2,
            product: _ctx.product
          }, null, 8, ["product"]))
        : _createCommentVNode("", true),
      (_ctx.product.isInternet && _ctx.product.price)
        ? (_openBlock(), _createBlock(ProductCardPricesInternet, {
            key: 3,
            product: _ctx.product
          }, null, 8, ["product"]))
        : _createCommentVNode("", true),
      (_ctx.product.price)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.product.isInternet)
              ? (_openBlock(), _createBlock(ProductCardAddons, {
                  key: 0,
                  "cart-item-key": _ctx.cartItemKey,
                  product: _ctx.product
                }, null, 8, ["cart-item-key", "product"]))
              : _createCommentVNode("", true),
            _createVNode(Expand, { title: "Produktdetails" }, {
              default: _withCtx(() => [
                (!_ctx.product.isInternet)
                  ? (_openBlock(), _createBlock(PriceDetailsTable, {
                      product: _ctx.product,
                      key: `details-${cardKey.value}`
                    }, null, 8, ["product"]))
                  : _createCommentVNode("", true),
                (_ctx.product.isInternet)
                  ? (_openBlock(), _createBlock(PriceDetailsTableInternet, {
                      product: _ctx.product,
                      key: `details-internet-${cardKey.value}`
                    }, null, 8, ["product"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_ctx.preview)
              ? (_openBlock(), _createBlock(BaseButton, {
                  key: 1,
                  "link-type": "button",
                  width: "full",
                  style: _normalizeStyle({
            background: `linear-gradient(90deg, ${branch.value?.customColor.primary}, ${branch.value?.customColor.secondary})`,
          }),
                  "text-align": "center",
                  onClick: _withModifiers(emitOrder, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.product.isInternet ? 'Tarif auswählen' : 'In den Warenkorb'), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showCalculator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(ProductCardCalculator, {
              branch: _ctx.product.branch,
              product: _ctx.product,
              "button-label": _ctx.product.isInternet ? 'Verfügbarkeit prüfen' : 'Preis berechnen'
            }, null, 8, ["branch", "product", "button-label"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})